import React from 'react'
import InterchangeabilitySlider from '../components/InterchangeabilitySlider'
import ColorSelector from '../components/ColorSelector'
import RequestInfoForm from '../components/RequestInfoForm'
import RequestModelForm from '../components/RequestModelForm'
// import AccessoriesModal from '../components/AccessoriesModal'
import Modal from '../components/Modal'
import Link from '../components/IntlLink'
import left from '../images/arrow-left.svg'
import right from '../images/arrow-right.svg'
import leftWhite from '../images/arrow-left-white.svg'
import rightWhite from '../images/arrow-right-white.svg'
import { FormattedMessage } from 'react-intl'
import { btoa } from 'isomorphic-base64';
import queryString from 'query-string';
import close from '../images/close.svg'
import plus from '../images/plus.svg'
import closeCircle from '../images/close-circle.svg'
import testPad from '../images/test.png'


class WorkTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      baseBitIndex: 0,
      optionalBitIndex: 0,
      baseColorIndex: 0,
      optionalColorIndex: 0,
      modal: null,
      accessoriesOn: false,
      skinImage: this.props.optionalBits[0] && this.props.optionalBits[0].mysecondskinPreview ?
        this.props.optionalBits[0].mysecondskinPreview.image.resize.src :
        null,
      padImage: this.props.optionalBits[0] && this.props.optionalBits[0].softpadPreview ?
        this.props.optionalBits[0].softpadPreview.image.resize.src :
        null,
    }
  }

  currentBaseBit() {
    return this.props.baseBits[this.state.baseBitIndex];
  }

  currentOptionalBit() {
    return this.props.optionalBits[this.state.optionalBitIndex];
  }

  baseColor() {
    return this.currentBaseBit().colors[this.state.baseColorIndex];
  }

  optionalColor() {
    return this.currentOptionalBit() &&
      this.currentOptionalBit().colors[this.state.optionalColorIndex];
  }

  baseColors() {
    return this.props.baseBits.map((bit, index) => (
      bit.colors[
        index === this.state.baseBitIndex ?
          this.state.baseColorIndex :
          0
      ]
    ));
  }

  optionalColors() {
    const {optionalBitIndex, optionalColorIndex, modal} = this.state
    return this.props.optionalBits.map((bit, index) => (
      bit.colors[
        index === optionalBitIndex ?
          optionalColorIndex :
          0
      ]
    ))
  }

  nextBaseBit() {
    const { baseBits } = this.props;
    const { baseBitIndex: index } = this.state;
    return baseBits[index == baseBits.length - 1 ? 0 : index + 1];
  }

  nextOptionalBit() {
    const { optionalBits } = this.props;
    const { optionalBitIndex: index } = this.state;
    return optionalBits[index == optionalBits.length - 1 ? 0 : index + 1];
  }

  prevBaseBit() {
    const { baseBits } = this.props;
    const { baseBitIndex: index } = this.state;
    return baseBits[index == 0 ? baseBits.length - 1 : index - 1];
  }

  prevOptionalBit() {
    const { optionalBits } = this.props;
    const { optionalBitIndex: index } = this.state;
    return optionalBits[index == 0 ? optionalBits.length - 1 : index - 1];
  }

  productName() {
    return (
      [this.currentBaseBit(), this.baseColor()] .filter(x => x).map(x => x.name).join(' ') + ' / ' +
      [this.currentOptionalBit(), this.optionalColor()] .filter(x => x).map(x => x.name).join(' ')
    )
  }

  productPrice() {
    const defaultBase = this.currentBaseBit().defaultPrice ? this.currentBaseBit().defaultPrice : 0
    const defaultOptional = this.currentOptionalBit() && this.currentOptionalBit().defaultPrice ? this.currentOptionalBit().defaultPrice : 0
    const basePrice = this.baseColor().price ? this.baseColor().price : defaultBase
    const optionalPrice = this.optionalColor() && this.optionalColor().price ? this.optionalColor().price : defaultOptional
    // const accessoryPrice = this.currentOptionalBit().defaultPrice ? this.currentOptionalBit().defaultPrice : 0
    return basePrice + optionalPrice
  }

  productSku() {
    return (
      [this.baseColor(), this.optionalColor()]
      .filter(x => x).map(x => x.sku).join('-')
    )
  }

  productImageUrl() {
    const crop = this.props.isTall ? '300,400,840,1150' : '300,400,840,900';

    let productImageUrl = `${this.baseColor().bitImage.url}?rect=${crop}&h=200`;

    if (this.optionalColor()) {
      productImageUrl += `&mark64=${btoa(this.optionalColor().bitImage.url + '?rect=' + crop + '&h=200')}&markalign=middle,center`;
    }

    return productImageUrl;
  }

  productImageEmailUrl() {
    const crop = this.props.isTall ? '840,1150' : '840,900';

    let productImageUrl = `${this.baseColor().bitImage.url}?h=500`;

    if (this.optionalColor()) {
      productImageUrl += `&mark64=${btoa(this.optionalColor().bitImage.url + '?&h=500')}&markalign=middle,center`;
    }

    return productImageUrl;
  }

  getId(bit) {
    return bit ? bit.id.match(/[0-9]+/)[0] : '';
  }

  productShareUrl() {
    const query = queryString.stringify({
      optionalBit: this.getId(this.currentOptionalBit()),
      optionalColor: this.getId(this.optionalColor()),
      baseBit: this.getId(this.currentBaseBit()),
      baseColor: this.getId(this.baseColor()),
    });

    return `https://www.kubikoff.com/chair?${query}`
  }

  handleCloseModal() {
    this.setState({ modal: null });
  }

  handleColorChange(index, isBase) {
    isBase
      ? this.setState({ baseColorIndex: index })
      : this.setState({ optionalColorIndex: index })
  }

  handleChangeBit(bitIndex, isBase) {
    this.handleCloseModal()
    const currentOptionalBit = this.props.optionalBits[bitIndex]

    const softpadPreview = !isBase && currentOptionalBit.softpadPreview ?
      currentOptionalBit.softpadPreview.image.resize.src :
      null

    const mysecondskinPreview = !isBase && currentOptionalBit.mysecondskinPreview ?
      currentOptionalBit.mysecondskinPreview.image.resize.src :
      null

    isBase
      ? this.setState({ baseBitIndex: bitIndex, baseColorIndex: 0 })
      : this.setState({ optionalBitIndex: bitIndex,
        optionalColorIndex: 0,
        padImage: softpadPreview, skinImage: mysecondskinPreview })
  }

  renderColorBox() {
    const { modal, accessoriesOn } = this.state;
    const { isCollection, cssModifier, baseBits, optionalBits } = this.props;

    const leftArrow = isCollection ? leftWhite : left
    const rightArrow = isCollection ? rightWhite : right

    const hasOptionalBits = this.props.optionalBits.length > 0
    return(
      <div className="color-selector__container">
        {
          hasOptionalBits &&
            <div className="color-selector__selected__left">
              <div>
                <p className={`page__text${cssModifier}`}>Shell colour – {this.optionalColor().name}</p>
                <span className={`page__small-title${cssModifier}`}>{this.currentOptionalBit().name}</span>
              </div>
              <div
                className={`button--round${cssModifier} color-selector__button--checked`}
                onClick={() => this.setState({ modal: "optionalBits" })}
              >
                <div style={{backgroundImage: `url('${this.optionalColor().swatch.resize.src}')`}}/>
              </div>
              {
                modal === "optionalBits" && this.props.optionalBits.length > 0 &&
                  <ColorSelector
                    bits={optionalBits}
                    handleColorChange={(color, index) => {
                      this.handleColorChange(index, false)
                    }}
                    handleCloseModal={() => this.handleCloseModal()}
                    color={this.optionalColor()}
                    slide={this.state.optionalBitIndex}
                    cssModifier="--tops"
                  />
              }
            </div>
        }
        {
          (!this.props.collection || this.props.collection.interchangeable) &&

            <div className='switch__container'>
              <FormattedMessage id='workTable.accessories' className='slider__accessories__title'/>
              <div className={`switch${accessoriesOn ? '--checked' : ''}`}
                onClick={() => this.setState({ accessoriesOn: !accessoriesOn, modal: null })}
              />
            </div>
        }
        <div className={`color-selector__selected__right${this.props.optionalBits.length === 0 ? '--alone' : ''}`}>
          <div
            className={`button--round${cssModifier} color-selector__button--checked`}
            onClick={() => this.setState({ modal: "baseBits" })}
          >
            <div style={{backgroundImage: `url('${this.baseColor().swatch.resize.src}')`}}/>
          </div>
          <div>
            <p className={`page__text${cssModifier}`}>{hasOptionalBits ? "Base colour" : "Colour"} — {this.baseColor().name}</p>
            <span className={`page__small-title${cssModifier}`}>{this.currentBaseBit().name}</span>
          </div>
          {
            modal === "baseBits" &&
              <ColorSelector
                bits={baseBits}
                handleColorChange={(color, index) => {
                  this.handleColorChange(index, true)
                }}
                handleCloseModal={() => this.handleCloseModal()}
                color={this.baseColor()}
                slide={this.state.baseBitIndex}
                cssModifier="--bases"
              />
          }
        </div>
      </div>
    )
  }

  renderAccessories() {
    const { modal, accessoriesOn } = this.state

    return (
      <div>
        {
          accessoriesOn && this.currentBaseBit().canHaveFeet &&
            this.renderPlus('feet')
        }
        {
          accessoriesOn && this.currentOptionalBit().mysecondskinPreview &&
            this.renderPlus('skin')
        }
        {
          accessoriesOn && this.currentOptionalBit().softpadPreview &&
            this.renderPlus('pad')
        }
        {
          accessoriesOn && this.currentBaseBit().stoolOption &&
            this.renderPlus('stool')
        }
        {
          this.props.accessoriesModal.map( (m) =>
            m.slug.includes(modal) && this.renderAccessoriesModal(modal, m)
          )
        }
        </div>
    )
  }

  renderAccessoriesModal(modal, m) {
    if ( m.slug.includes('diamond') && !this.currentBaseBit().name.toLowerCase().includes('diamond') ||
      m.slug.includes('slice') && !this.currentBaseBit().name.toLowerCase().includes('slice') ) {
      return
    }
    return (
        <div className={`slider__modal__accessories--${modal}`} key={m.slug}>
          <img
            src={closeCircle}
            className="button--close"
            onClick={() => this.handleCloseModal()}
          />
          <h3 className="slider__modal__accessories__title">{m.title}</h3>
          <span>
            <FormattedMessage id="home.designBy" />
          </span>
          <span> – </span>
          <span>
            { m.designers.map(d => d.name).join(', ')  }
          </span>
          <img
            className="slider__modal__accessories__image"
            src={m.modalImage.resize.src}
          />
          <a
            className="button--dark slider__modal__accessories__link"
            href={`${m.link}`}
            target="_blank"
          >
            <FormattedMessage id="collection.findOutMore" />
          </a>
        </div>
    )
  }

  renderPlus(type) {
    return (
      <img className={`slider__modal__accessories__plus--${type}`}
        src={plus}
        onClick={() => this.setState({ modal: `${type}`})}
      />
    )
  }

  render() {
    const { isCollection, collection } = this.props
    const { modal, accessoriesOn } = this.state

    return (
      <div>
        {
          this.baseColors() &&
            <div style={{position: "relative"}}>
              { this.renderAccessories() }
              <InterchangeabilitySlider
                isTall={this.props.isTall}
                baseBitsImages={
                  this.baseColors().map(c => c.bitImage)
                }
                optionalBitsImages={
                  this.optionalColors().map(c => c.bitImage)
                }
                changeSlide={(currentBit, isBase) => {
                  this.handleChangeBit(currentBit, isBase)
                }}
                isCollection={isCollection}
                nextTopBit={this.nextOptionalBit()}
                prevTopBit={this.prevOptionalBit()}
                nextBaseBit={this.nextBaseBit()}
                prevBaseBit={this.prevBaseBit()}
              />
              <div className='slider__price'>
                { this.productPrice().toFixed(2) + '€' }
              </div>
              {
                modal === 'pad' &&
                  <div className="slider__accessory__preview">
                    <img
                      src={this.state.padImage}
                    />
                  </div>
              }
              {
                modal === 'skin' &&
                  <div className="slider__accessory__preview">
                    <img
                      src={this.state.skinImage}
                    />
                  </div>
              }
            </div>
        }

        <div className="color-selector">
          {this.renderColorBox()}
          <Modal
            visible={modal === 'requestInfo'}
            onClose={() => this.handleCloseModal()}
          >
            <RequestInfoForm
              product={this.productName()}
              sku={this.productSku()}
              price={this.productPrice().toFixed(2) + '€'}
              productUrl={this.productImageUrl()}
              productImageEmailUrl={this.productImageEmailUrl()}
              onSubmit={() => this.handleCloseModal()}
            />
          </Modal>
          {
            collection &&
              <Modal
                visible={modal === 'requestModel'}
                onClose={() => this.handleCloseModal()}
              >
                <RequestModelForm
                  collectionName={collection.name}
                  collectionId={collection.id.match(/[0-9]+/)[0]}
                  onSubmit={() => this.handleCloseModal()}
                />
              </Modal>
          }
        </div>

        <div className="buttons__container">
          {
            collection && collection.dataSheet &&
              <a
                href={collection.dataSheet.url} download
                target="_blank"
                className="button--dark"
              >
                <FormattedMessage id="workTable.sheet" />
              </a>
          }
          <button className="button--red" onClick={() => this.setState({ modal: 'requestInfo' })}>
            <FormattedMessage id="workTable.iWantThis" />
          </button>
          {
            collection && collection.instructionManual &&
              <a
                href={collection.instructionManual.url} download
                target="_blank"
                className="button--dark"
              >
                <FormattedMessage id="workTable.manual" />
              </a>
          }
          {
            false && collection && collection.threesixty &&
              <button className="button--dark" onClick={() => this.setState({ modal: 'requestModel' })}>
                <FormattedMessage id="workTable.request3dModel" />
              </button>
          }
        </div>
          <div className="buttons__container">
            <a
              href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.productShareUrl())}`}
              target="_blank"
              className="page__text--dark"
            ><FormattedMessage id="workTable.share" /></a>
        </div>
      </div>
    )
  }
}

export default WorkTable



// WEBPACK FOOTER //
// ./src/components/WorkTable.js